import { jsx as _jsx } from "react/jsx-runtime";
import { DocumentPreview } from '../../../components/artifacts/document-preview';
import { TextArtifactEditor } from '../../../components/artifacts/text-editor';
export const textArtifact = {
    kind: 'text',
    description: 'Work with text content like drafting essays and emails.',
    Preview: ({ title, content, isStreaming, onExpand })=>/*#__PURE__*/ _jsx(DocumentPreview, {
            title: title,
            kind: "text",
            content: content,
            isStreaming: isStreaming,
            onExpand: onExpand
        }),
    Editor: ({ value, onChange })=>/*#__PURE__*/ _jsx(TextArtifactEditor, {
            value: value,
            onChange: onChange
        })
};
